import styled from 'styled-components';

export const Section = styled.section`
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  height: 98vh;
  height: calc(100vh - 100px);

  @media only screen and (max-width: 979px) {
    height: auto;
  }

  @media only screen and (max-width: 767px) {
    border-bottom: 0;
  }

  .container {
    height: 100%;

    & > div {
      position: relative;
      height: 100%;
      height: calc(100% - 8px);

      & > .row {
        height: 100%;
      }
    }
  }

  .hero-content {
    position: relative;
    z-index: 3;
    padding-top: 15px;
    padding-bottom: 55px;

    @media only screen and (max-width: 767px) {
      padding-bottom: 210px;
    }

    h1 {
      font-size: 48px;
      letter-spacing: -0.36px;
      line-height: 59px;
      max-width: 460px;

      &.title-0 {
        max-width: 400px;
      }

      @media only screen and (max-width: 990px) {
        font-size: 38px;
        line-height: 49px;
      }
    }

    h2 {
      font-family: 'Proxima Nova';
      font-size: 18px;
      letter-spacing: 0.2px;
      line-height: 28px;
      font-weight: 400;
      margin-bottom: 22px;
    }

    &-border {
      margin-left: 30px;
      border-left: 2px solid ${({ theme: { colors } }) => colors.pink};
      padding-left: 20px;

      @media only screen and (max-width: 767px) {
        margin-left: 0;
        border-left: none;
        padding-left: 0;

        p {
          font-size: 16px;
          line-height: 23px;
        }
      }
    }
  }

  .button {
    border-radius: 2px;
    background-color: ${({ theme: { colors } }) => colors.pink};
    min-width: 160px;
    padding: 6px 0;
    color: ${({ theme: { colors } }) => colors.white};
    font-size: 16px;
    letter-spacing: 0.18px;
    line-height: 28px;

    &:hover {
      color: ${({ theme: { colors } }) => colors.white};
      background-color: ${({ theme: { colors } }) => colors.pinkHover};
    }

    @media only screen and (max-width: 767px) {
      width: 100%;
      padding: 10px;
      border-radius: 0;
    }
  }

  .hero-image {
    display: block;
    width: 547px;
    max-width: 100%;
    margin-top: -92px;
    margin-left: auto;
    max-height: 98vh;
    object-fit: cover;
    object-position: right;

    @media only screen and (max-width: 767px) {
      margin-top: -300px;
      z-index: 2;
      position: relative;
    }
  }

  .navigation {
    li {
      color: #ffffff;
      font-size: 15px;
      letter-spacing: 0.17px;
      line-height: 28px;
      list-style-type: none;

      button {
        display: inline-block;
        color: #fff;
        opacity: 0.4;
        padding: 0 0 15px 0;
        background: unset;
        border: 0;
        border-bottom: 1px solid transparent;

        &:hover {
          opacity: 1;
        }
      }

      &.active {
        button {
          opacity: 1;
          border-bottom: 1px solid ${({ theme: { colors } }) => colors.white};
        }
      }
    }
  }

  .navigation {
    position: relative;
    z-index: 9;
    margin-top: -30px;
  }

  .image-canvas {
    height: 684px;
    width: 547px;
    margin-top: -92px;
    margin-left: auto;
  }

  /* Transitions */

  .hero-transition {
    &-enter {
      opacity: 0;

      h1 {
        opacity: 0;
        transform: translateY(15px);
        transition: all 1s cubic-bezier(0, 0, 0.2, 1);
        transition-delay: 0.5s;
      }

      .hero-content-border {
        opacity: 0;
        transform: translateY(30px) scaleY(1.05);
        transition: all 1.1s cubic-bezier(0, 0, 0.2, 1);
        transition-delay: 0.6s;
      }

      img {
        opacity: 0;
        transform: translateY(30px);
        transition: all 1.2s cubic-bezier(0, 0, 0.2, 1);
      }

      &-active {
        opacity: 1;

        h1,
        .hero-content-border,
        img {
          opacity: 1;
          transform: translate(0, 0) scale(1, 1);
        }
      }
    }

    &-exit {
      opacity: 0;
      max-height: 0;
      position: absolute;
      display: none;
      visibility: hidden;
    }
  }
`;
